import {
  Award,
  Presentation,
  Globe,
  Lightbulb,
  TrendingUp,
  Shield,
  Package,
} from "lucide-react";
export const customStyles = {
  control: (provided, state) => {
    const isUniquePage =
      state.selectProps.className?.includes("unique-page-select");
    return {
      ...provided,
      backgroundColor: isUniquePage ? "#4F22D8" : "white",
      height: "40px",
      minHeight: "40px",
      width: "100%",
      borderRadius: "8px",
      border: isUniquePage
        ? state.isFocused
          ? "2px solid #4F22D8"
          : "1px solid #ccc"
        : "1px solid #ccc",
      display: "flex",
      alignItems: "center",
      padding: "0 12px",
      boxShadow:
        state.isFocused && isUniquePage
          ? "0 0 0 2px rgba(142, 11, 236, 0.2)"
          : "none",
      cursor: "pointer",
      "&:hover": {
        borderColor: isUniquePage && "#4F22D8",
      },
    };
  },

  valueContainer: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
    width: "100%",
    height: "100%",
    overflow: "hidden",
  }),

  singleValue: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    color: "#202020",
    fontSize: "14px",
    fontWeight: "500",
    height: "100%",
    padding: "0",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  }),

  placeholder: (provided) => ({
    ...provided,
    color: "#A8A39E",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    height: "100%",
  }),

  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    zIndex: 9999,
    marginTop: "4px",
    padding: "0",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  }),

  menuPortal: (base) => ({ ...base, zIndex: 9999 }),

  input: (provided) => ({
    ...provided,
    margin: "0px",
    padding: "0px",
    height: "100%",
    color: "#202020",
    fontSize: "14px",
    fontWeight: "500",
  }),

  option: (provided, state) => ({
    ...provided,
    padding: "6px 16px",
    fontSize: "14px",
    color: state.isSelected ? "white" : "#202020",
    backgroundColor: state.isSelected ? "#4F22D8" : "white",
    borderLeft: state.isSelected ? "4px solid white" : "4px solid transparent",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: state.isSelected ? "#4F22D8" : "#FAFAFA",
      borderLeft: "4px solid white",
      color: state.isSelected ? "white" : "#4F22D8",
    },
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    cursor: "pointer",
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#686767",
    "&:hover": {
      color: "#8E0BEC",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),
};

// Helper function to get cookie value by name
export const getCookie = (name) => {
  if (typeof document === "undefined") return null;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }
  return null;
};

export const founder_members = [
  { sno: 1, name: "All Husain, S." },
  { sno: 2, name: "Allada Narayana Swamy" },
  { sno: 3, name: "Amarnath Sharma, H.V." },
  { sno: 4, name: "Anantheswara Bhat, D." },
  { sno: 5, name: "Anil B. Ghanekar" },
  { sno: 6, name: "Apuchand, E." },
  { sno: 7, name: "Arivazhagan, U." },
  { sno: 8, name: "Arokiasamy, J." },
  { sno: 9, name: "Arul Victor Suresh" },
  { sno: 10, name: "Ashoka, S." },
  { sno: 11, name: "Balaraman, R." },
  { sno: 12, name: "Balu, P." },
  { sno: 13, name: "Balu, S." },
  { sno: 14, name: "Basheer Ahamed, N.A." },
  { sno: 15, name: "Bor-Yu Leu" },
  { sno: 16, name: "Chandrasekar, S." },
  { sno: 17, name: "Charles John Bhaskar, T." },
  { sno: 18, name: "Debananda Naik" },
  { sno: 19, name: "Dhanakoti Ramesh Kumar" },
  { sno: 20, name: "Dipti Chandra Das" },
  { sno: 21, name: "Edward Danish" },
  { sno: 22, name: "Gandhi Natarajan, V." },
  { sno: 23, name: "Geethu Thomas" },
  { sno: 24, name: "Govind Deshpande, M." },
  { sno: 25, name: "James David" },
  { sno: 26, name: "Jeyaraaman, C.P." },
  { sno: 27, name: "John A. Joseph" },
  { sno: 28, name: "John M. John" },
  { sno: 29, name: "Jose Kutty, P.A." },
  { sno: 30, name: "Joshi K. Shankar" },
  { sno: 31, name: "Kalidasan, K." },
  { sno: 32, name: "Kamlesh Gupta" },
  { sno: 33, name: "Kannan, R." },
  { sno: 34, name: "Kannan, D." },
  { sno: 35, name: "Konakanti Madhusudhan Reddy" },
  { sno: 36, name: "Krishna Reddy, Y." },
  { sno: 37, name: "Mahendra, T.M." },
  { sno: 38, name: "Mahesh N. Prabhu" },
  { sno: 39, name: "Mastan Rao, B." },
  { sno: 40, name: "Mopati Uma Mahesh Reddy" },
  { sno: 41, name: "Murthy, Y.S.N." },
  { sno: 42, name: "Muthukaruppan, S." },
  { sno: 43, name: "Muthukrishnan, P." },
  { sno: 44, name: "Nandeesha, M.N." },
  { sno: 45, name: "Nithyanandham, K." },
  { sno: 46, name: "Palaniswami, K.S." },
  { sno: 47, name: "Panchayuthapani D." },
  { sno: 48, name: "Pandiyan, T.R." },
  { sno: 49, name: "Pradep, S." },
  { sno: 50, name: "Prakash, K.V." },
  { sno: 51, name: "Raja Kumar, T." },
  { sno: 52, name: "Rajendra Shrikrishna Damle" },
  { sno: 53, name: "Ramakrishnan Kulasekaran" },
  { sno: 54, name: "Ramraj, D." },
  { sno: 55, name: "Raveendra Kumar" },
  { sno: 56, name: "Ravi Fotedar" },
  { sno: 57, name: "Ravi Sekhar Ganisetty" },
  { sno: 58, name: "Ravichandran, P." },
  { sno: 59, name: "Regunathan, C." },
  { sno: 60, name: "Riji John, K." },
  { sno: 61, name: "Rufus Kitto, M." },
  { sno: 62, name: "Sahu, B.K." },
  { sno: 63, name: "Sait Sahul Hameed, A." },
  { sno: 64, name: "Saji Chacko" },
  { sno: 65, name: "Sakkaravarthi, K." },
  { sno: 66, name: "Samant S. Vishwanath" },
  { sno: 67, name: "Sandip Ramesh Ahirrao" },
  { sno: 68, name: "Sangamaheswaran, A.P." },
  { sno: 69, name: "Sankar, M." },
  { sno: 70, name: "Sankar, S.S." },
  { sno: 71, name: "Sankarapandian Selvaraj" },
  { sno: 72, name: "Santhana Krishnan, S." },
  { sno: 73, name: "Santiago, T.C., Dr." },
  { sno: 74, name: "Selvaraj, S.K." },
  { sno: 75, name: "Senthil Kumar, V." },
  { sno: 76, name: "Senthil Kumar, P.K." },
  { sno: 77, name: "Shankar Babu, S." },
  { sno: 78, name: "Shankar, T." },
  { sno: 79, name: "Sharma Manoj Mohanlal" },
  { sno: 80, name: "Shivarama" },
  { sno: 81, name: "Sivalingam, S." },
  { sno: 82, name: "Srikanth Nayak, S." },
  { sno: 83, name: "Srinivas, G.G." },
  { sno: 84, name: "Srinivasan, R." },
  { sno: 85, name: "Sriram Ramarathnam" },
  { sno: 86, name: "Surendran, V." },
  { sno: 87, name: "Thiyagarajan" },
  { sno: 88, name: "S. Uday Ram Jothy" },
  { sno: 89, name: "Udayakumara, K." },
  { sno: 90, name: "Venkatesan, V." },
  { sno: 91, name: "Venkatramman, T." },
  { sno: 92, name: "Vidubalan, K." },
  { sno: 93, name: "Vijayan, K.K." },
  { sno: 94, name: "Viju J. Jacob" },
  { sno: 95, name: "Vinay Kumar, N." },
];

export const speakerBios = {
  1: {
    name: "Saji Chacko",
    role: "President, Society of Aquaculture Professionals",
    bio: "Saji Chacko is a postgraduate aquaculture professional with over three decades of hands-on experience in shrimp farming. He pioneered L. vannamei culture in Gujarat and has worked across India and overseas. Currently, he serves as President of the Society of Aquaculture Professionals, driving industry collaboration, innovation, and sustainable growth, with a strong focus on policy, capacity building, and sector leadership.",
  },
  2: {
    name: "D.V. Swamy",
    role: "IAS, Chairman, Marine Products Export Development Authority",
    bio: "D V Swamy, IAS (2001 batch), has been Chairman of the Marine Products Export Development Authority since August 2022, providing strategic leadership to India's seafood and shrimp export sector. A Harvard Kennedy School MPA alumnus, he brings strong administrative depth and currently holds additional charge as Chairperson of the Coastal Aquaculture Authority of India.",
  },
  // 3: {
  //   name: "K.C. Devasenapathi",
  //   role: "IAS, Secretary, Coastal Aquaculture Authority",
  //   bio: "",
  // },
  4: {
    name: "Dr. Kuldeep Kumar Lal",
    role: "Director, ICAR-Central Institute of Brackishwater Aquaculture",
    bio: "Dr. Kuldeep K. Lal is Director of ICAR-Central Institute of Brackishwater Aquaculture, Chennai. A leading authority in aquaculture genetics, he has over 32 years of research experience spanning shrimp and fish genetic resources, FAO-led global initiatives, aquatic animal disease surveillance, and genetic improvement programs for Indian white shrimp, with over 200 scientific publications to his credit.",
  },
  // 5: {
  //   name: "Dr. Bijay Kumar Behera",
  //   role: "Chief Executive, National Fisheries Development Board",
  //   bio: "",
  // },
  6: {
    name: "Robins MacIntosh",
    role: "Executive Vice President, Charoen Pokphand Foods, Thailand",
    bio: "Robins McIntosh is the Keynote Speaker at Aqua India 2026 and Executive Vice President at Charoen Pokphand Foods (CPF), Thailand. A pioneer of zero water-exchange intensive shrimp farming, he brings over three decades of global leadership across feeds, hatcheries, genetics, and biosecure production systems, offering a rare strategic perspective on the future of sustainable, technology-driven shrimp aquaculture worldwide.",
  },
  7: {
    name: "Ravikumar Yellanki",
    role: "Managing Director, Vaisakhi Marine Resources",
    bio: "Ravi Kumar Yellanki is a senior leader in India's shrimp aquaculture industry with over two decades of experience. Managing Director of Vaisakhi Marine Resources, President of AISHA and Past President of SAP, he is known for advancing bio-secure hatchery systems, quality seed production, sustainable aquaculture practices, and strategic industry thought leadership through regular commentary.",
  },
  8: {
    name: "Willem van der Pijl",
    role: "Owner, Shrimp Insights",
    bio: "Willem van der Pijl is owner of Shrimp Insights and co-founder of the Global Shrimp Forum, with over 15 years' experience across Europe, Asia, Latin America and the US, delivering shrimp market intelligence, consulting, industry platforms, and supporting research, investment, and sustainability initiatives.",
  },
  9: {
    name: "Joash Mathew",
    role: "Shrimp Analyst, Kontali",
    bio: "Joash Mathew is a Shrimp Analyst at Kontali. He has a technical background in biotechnology with specialisation in food technology. Furthermore, he has extensive experience in scientific, regulatory and policy affairs, having worked in European and international seafood industry associations.",
  },
  10: {
    name: "Nitin Awasthi",
    role: "Equity Research Analyst, InCred Research",
    bio: "Nitin Awasthi is an Equity Research Analyst at InCred Research, known for deep thematic work in agri-processing, with focused coverage of seafood and shrimp processing, analysing global supply–demand dynamics, exporter competitiveness, and small-cap value creation in Indian shrimp companies.",
  },
  11: {
    name: "Dr. Ramesh Kumar D",
    role: "Managing Director, Salem Microbe Pvt Ltd",
    bio: "Dr. Ramesh Kumar Dhanakoti, Managing Director of Salem Microbe Pvt Ltd, is a seasoned microbiologist with deep expertise in aquaculture and poultry microbiomes. His work spans microbial genomics, bacteriophages, diagnostics, and vaccines, underpinned by strong regulatory leadership and a proven record of translating science into scalable, globally relevant solutions.",
  },
  12: {
    name: "Dr. Victoria Alday Sanz",
    role: "Veterinarian and Shrimp Health Expert",
    bio: "Dr. Victoria Alday-Sanz is a veterinarian with an MSc and PhD from the University of Stirling and over 35 years of global leadership in shrimp health. Her expertise spans shrimp diseases, diagnostics, biosecurity, genetics, and SPF/SPT programs. She has led aquatic health programs across Latin America and the Middle East and is a widely published authority on shrimp health management.",
  },
  13: {
    name: "Dr. Stephen G Newman",
    role: "Aquaculture Scientist",
    bio: "Dr Stephen Newman is a globally respected aquaculture scientist with 47 years of industry experience. He earned his PhD from the University of Miami and has pioneered advances in fish vaccines, shrimp genetics, biosecurity, probiotics, and sustainability auditing. A prolific writer, consultant, and speaker, he has worked with farmers and companies across more than 55 countries worldwide.",
  },
  14: {
    name: "Prof. Andrew Shinn",
    role: "Aquaculture Expert",
    bio: "Professor Dr. Andrew Shinn is a global technical expert in aquatic animal health with Benchmark Advanced Nutrition (INVE). British by origin and grounded in a farming upbringing, he brings over 35 years of hands-on experience spanning health management, welfare, and biosecurity. An Honorary Professor at the University of Stirling and a prolific scientific author, he is widely respected for translating rigorous science into practical, farm-ready solutions for global aquaculture.",
  },

  15: {
    name: "Dr Victor Suresh",
    role: "Managing Director, Bentoli Agrinutrition India Pvt. Ltd., India",
    bio: "Dr. Victor Suresh, PhD, has nearly three decades of global experience in aqua feed nutrition and formulation, beginning with Ralston Purina International. Long associated with Bentoli, he has led its India business and global technical strategy. He currently serves as Technical Director at Growel Feeds and is a founding member and past President of the Society of Aquaculture Professionals.",
  },
  16: {
    name: "Dr. K. Ambashankar",
    role: "Principal Scientist & Head, Nutrition, Genetics & Biochemistry, ICAR-Central Institute of Brackishwater Aquaculture, India",
    bio: "Dr. Ambashankar is a senior scientist at ICAR-CIBA heading the Nutrition Genetics and Biotechnology Division, with expertise in advanced aqua feeds, functional nutrition, enzymes, sustainability and feed processing. He has led national and international projects, commercialised feed technologies, published 130+ papers, holds four patents, guided doctoral scholars, developed BIS feed standards, and received prestigious ICAR awards.",
  },
  17: {
    name: "Dr. Daranee Seguin",
    role: "Product Director Shrimp, Aker Qrill Company, Thailand",
    bio: "Dr. Daranee Seguin, PhD, is an aquaculture nutrition and feed formulation expert with over 16 years of global industry experience. Currently QRILL Product Director – Shrimp and an international consultant, she specialises in functional, cost-effective feeds for Pacific white shrimp (Litopenaeus vannamei), with strong expertise in feed innovation, sustainability, and feed mill management.",
  },
  18: {
    name: "Dr. Jean-Benoit Darodes de Tailly",
    role: "Global Business Director, Phileo by Lesaffre, France",
    bio: "Dr. Jean-Benoît Darodes de Tailly, PhD, is Global Business Developer – Shrimp at Phileo by Lesaffre. A marine biologist by training, he leads global initiatives in shrimp health, functional nutrition, and disease mitigation, translating field research into scalable, sustainable solutions for shrimp farmers across Asia and emerging markets.",
  },
  19: {
    name: "Dr. M. Rajalekshmi",
    role: "Global Director of Research & Development, Kemin AquaScience, India",
    bio: "Rajalekshmi M. is Global Director of R&D at Kemin AquaScience, a Kemin Industries business unit. With 18 years of leadership, she drives global research on aquaculture functional ingredients, nutrition, feed quality, disease management, and immunology. She holds a PhD from CIFE (ICAR) and is widely published with multiple patents.",
  },
  20: {
    name: "Mr. B. Ravikumar",
    role: "Vice President - Sales & Technical, Growel Feeds, India",
    bio: "B. Ravikumar is an aquaculture professional with over 25 years of international experience across Asia and Africa. A B.F.Sc. and M.F.Sc. graduate of TANUVAS, he has worked with NACA, WorldFish, and FAO, managed integrated shrimp farms in Africa, and currently serves as Vice President – Sales & Technical at Growel Feeds Pvt. Ltd.",
  },
  21: {
    name: "Dr. P.E. Vijay Anand",
    role: "Center Lead for the India Soy Excellence Center (SEC) Program, U.S. Soybean Export Council, India",
    bio: "Dr. P. E. Vijay Anand is Center Lead for the India Soy Excellence Center under the U.S. Soybean Export Council, driving workforce development and curriculum design. With long-standing USSEC experience across aquaculture, poultry, and dairy, he brings strong industry and managerial expertise. He holds fisheries degrees from UAS Bengaluru and a PhD from CUSAT.",
  },
  22: {
    name: "Ms. Kavitha Reddy Yarabolu",
    role: "Industry Professional",
    bio: "Kavitha Reddy is a Director at Geekay Group and I & V Bio India, with a professional background in hotel management from Manipal University. Drawing on a strong aquaculture legacy, she leads domestic shrimp and seafood promotion through consumer brands Kai and Rolled by Kai, making seafood accessible, convenient, and relevant for everyday Indian consumers.",
  },
  23: {
    name: "Arjun Gadre",
    role: "Market Specialist",
    bio: "Arjun Gadre is the Managing Director of Gadre Marine Export, a leading integrated seafood processor and exporter from India. He drives strategic growth, global market expansion, and value-added innovation, with a sharp focus on sustainability, technology adoption, and premium ready to-eat seafood—positioning Gadre Marine Export as a trusted, future-ready global partner. ​",
  },
  24: {
    name: "Mr. S. Santhana Krishnan",
    role: "Founder, Marine Technologies (Maritech)",
    bio: "S. Santhana Krishnan is a marine biologist, aquaculture consultant, and entrepreneur who founded Marine Technologies (Maritech) in 1989. Based in India, he has led shrimp and marine finfish projects across Asia, the Middle East, and Africa. A Founder President of SAP, his interests include RAS, biosecurity, sustainable aquaculture planning, and certification programmes.",
  },
  26: {
    name: "Zubin Minoo Mehta",
    role: "Operations & Sales Lead, Mindhola Foods",
    bio: "Zubin Minoo Mehta is a seasoned seafood professional with over 25 years across farming, processing, and sales. An M.Sc. in Aquatic Biology, he leads Operations & Sales at Mindhola Foods, where he built a state-of-the-art facility, scaling freezing capacity from 82 to 162 MT/day while driving value-added products and volume-led growth.",
  },
  27: {
    name: "Manavendra Rao",
    role: "Industry Professional",
    bio: "Vemulapalli Manavendra Rao is a seasoned food technologist with 48 years of experience across shrimp processing, farming, product development, and SPF P.monodon domestication. Currently Business Manager at Aqualma–Unima Group, Madagascar, he has played a pivotal role in building one of the world’s most respected integrated monodon shrimp programs and genetics platforms. ​",
  },
  28: {
    name: "M. Sudhakar",
    role: "Industry Expert",
    bio: "Sudhakaran M is a seasoned fisheries professional with nearly three decades of experience across the aquaculture value chain. An ICAR Scholar and fisheries science postgraduate, he leads an integrated business from hatchery to processing, known for pioneering practices,operational efficiency, and strong commitment to mentoring professionals and building sustainable value in Indian aquaculture. ​",
  },
  29: {
    name: "Pervez Ahmed Khan",
    role: "CEO, S A Exports & Secretary, SEAIWB",
    bio: "Pervez Ahmed Khan is CEO of S A Exports and Secretary of SEAIWB. With over 15 years in Eastern India's aquaculture exports, he drives value addition, product diversification, and market-led strategies. An engineering graduate with an MBA, he advises on sustainability, risk mitigation, and has served on the West Bengal Government's Fishery & Seafood Core Group.",
  },
  30: {
    name: "Dr. G. Ramesh",
    role: "Technical Sales Advisor, Wenger Manufacturing",
    bio: "Dr. Ramesh Gangatharan is a senior aquaculture professional with over 30 years of global experience. He is Technical Sales Advisor, AquaFeed & Companion Animal Division at Wenger Manufacturing LLC, covering Asia, the Middle East, and Africa. A PhD in Coastal Aquaculture, he also serves as Vice President – Events at the Society of Aquaculture Professionals, driving initiatives on sustainable shrimp farming and domestic shrimp marketing.",
  },
  31: {
    name: "John Deiner",
    role: "Founder and CEO, Vertical Oceans",
    bio: "John F. Diener is Founder and CEO of Vertical Oceans, an AI-native sustainable aquaculture platform backed by Khosla Ventures and SOSV. He previously led Gold Coin-SyAqua's turnaround and scaled food-tech startups. An investor and mentor, he blends AI, systems design, and bioengineering to advance sustainable seafood.",
  },
  32: {
    name: "Pavan Kosaraju",
    role: "CEO, AquaExchange Agritech",
    bio: "Pavan Kosaraju is CEO of AquaExchange Agritech, leveraging bioengineering, IoT, and machine learning to digitize shrimp farming. His platform has automated over 25% of India's shrimp farms. With 20 years across Infosys, SAP Labs, and KPMG, he blends deep tech, finance, and aquaculture to deliver measurable farmer value.",
  },
  33: {
    name: "Shan Kadavil",
    role: "Co-founder and CEO of Freshtohome",
    bio: "Shan Kadavil is the Co-founder and CEO of Freshtohome, the world’s largest vertically integrated fish and meat e-commerce platform, serving over 5 million customers across India, the UAE, and global markets. He is redefining the food supply chain with a sharp focus on chemical-free food, farmer empowerment, and tech-led scale.",
  },
  34: {
    name: "Chef K. Thirugnanasambantham",
    role: "Celebrity Chef",
    bio: "Chef K. Thirugnanasambantham, widely known as Chef K. Thiru, is a distinguished hospitality academician and culinary strategist with over three decades of experience across industry and academia. A former Principal of WGSHA, Manipal, and senior executive with ITC Hotels, he is currently the Founding Dean at Mahindra University, building a world-class hospitality and culinary education ecosystem.​",
  },

  35: {
    name: "Varsha Easwaran​",
    role: "Celebrity Nutritionist / Dietician",
    bio: "Varsha Easwaran is a clinical nutritionist based in Chennai and the founder of Optimal Nutrition Protocol. She works with a practical, evidence-based approach, helping people make better food choices that fit real life. With a background in clinical nutrition and food science, her work covers metabolic health, women’s health, weight management,and performance nutrition, with a strong focus on clarity,balance, and long-term wellbeing.​",
  },

  36: {
    name: "Dr. Rajeev Jha",
    role: " Innovative Farming Systems in China ",
    bio: "Dr. Rajeev Jha is a senior aquaculture professional with over 25 years of experience across Southeast Asia and China. Specialising in farm solutions, management, and functional product development, he blends scientific depth with commercial scale. He holds a PhD from Zhejiang University and a Master’s from ICAR-CIFE, driving sustainable productivity and cross-border partnerships.",
  },
  37: {
    name: "K.C. DEVASENAPATHI,IAS",
    role: "IAS, Secretary, Coastal Aquaculture Authority (CAA), Department of Fisheries, Ministry of Fisheries, Animal Husbandry and Dairying, Government of India. ",
    bio: "IAS, Secretary, Coastal Aquaculture Authority (CAA), Department of Fisheries, Ministry of Fisheries, Animal Husbandry and Dairying, Government of India. ",
  },
  38: {
    name: "Dr. Kuldeep Kumar Lal",
    role: "Director, ICAR- Central Institute of Brackishwater Aquaculture, Ministry of Agriculture, Government of India ",
    bio: "Dr. Kuldeep K. Lal is Director of ICAR-Central Institute of Brackishwater Aquaculture, Chennai. A leading authority in aquaculture genetics, he has over 32 years of research experience spanning shrimp and fish genetic resources, FAO-led global initiatives, aquatic animal disease surveillance, and genetic improvement programs for Indian white shrimp, with over 200 scientific publications to his credit.",
  },
  39: {
    name: "Dr. Bijay Kumar Behera, ARS",
    role: "Dr. Bijay Kumar Behera, Chief Executive, The National Fisheries Development Board (NFDB), Department of Fisheries, Ministry of Fisheries, Animal Husbandry & Dairying, Government of India ",
    bio: "Chief Executive, National Fisheries Development Board, Hyderabad, Telangana, April 2024 onwards.Dean, College of Fisheries, Rani Lakshmi Bai Central Agricultural University, Jhansi, Uttar Pradesh, 2023-2024; Senior Scientist, Principal Scientist, Head of Division, ICAR-Central Inland Fisheries Research Institute, Barrackpore, Kolkata, 2008-2022; Scientist, ICAR-RC for NEH Region, Manipur Center, Imphal, 2003-2008; Scientist, ICAR-RC for NEH Region, Shillong, 2003. ",
  },
};

export const programData = {
  eventTitle: "AQUA INDIA",
  eventSubtitle: "Program Schedule",
  day1: {
    date: "30 January 2026",
    sessions: [
      {
        id: "inaugural",
        title: "Inaugural Session",
        icon: Award,
        venue: "Main Convention Hall",
        items: [
          {
            type: "Presidential Address",
            speaker: "Saji Chacko",
            role: "President, Society of Aquaculture Professionals",
            bioId: 1,
          },
          {
            type: "Address by Chief Guest",
            speaker: "D.V. Swamy",
            role: "IAS, Chairman, THE MARINE PRODUCTS EXPORT DEVELOPMENT AUTHORITY, Ministry of Commerce and Industry, Government of India.",
            bioId: 2,
          },
          // {
          //   type: "Address by Guest of Honour",
          //   speaker: "K.C. Devasenapathi",
          //   role: "IAS, Secretary, Coastal Aquaculture Authority (CAA), Department of Fisheries, Ministry of Fisheries, Animal Husbandry and Dairying, Government of India. ",
          //   bioId: 37,
          // },
          // {
          //   type: "Address by Guest of Honour",
          //   speaker: "Dr. Kuldeep Kumar Lal",
          //   role: "Director, ICAR- Central Institute of Brackishwater Aquaculture, Ministry of Agriculture, Government of India ",
          //   bioId: 38,
          // },
          // {
          //   type: "Address by Guest of Honour",
          //   speaker: "Dr. Bijay Kumar Behera, ARS",
          //   role: "Dr. Bijay Kumar Behera, Chief Executive, The National Fisheries Development Board (NFDB), Department of Fisheries, Ministry of Fisheries, Animal Husbandry & Dairying, Government of India ",
          //   bioId: 39,
          // },
        ],
      },
      {
        id: "keynote",
        title: "Keynote Speech",
        icon: Presentation,
        venue: "Main Convention Hall",
        items: [
          {
            speaker: "Robins McIntosh",
            role: "Executive Vice President, Charoen Pokphand Foods, Thailand.",
            bioId: 6,
          },
        ],
      },
      {
        id: "session1",
        title: "Session 1 - Global Trade & Market Shifts",
        icon: Globe,
        venue: "Conference Room A",
        moderator: "Ravikumar Yellanki",
        bioId: 7,
        talks: [
          {
            title: "Reimagining India's Role in the Global shrimp value chain",
            speaker: "D.V. Swamy",
            bioId: 2,
          },
          {
            title:
              "Understanding the growth potential of the European continent: a Deep dive into import statistics and the markets and players driving demand.",
            speaker: "Willem van der Pijl",
            bioId: 8,
          },
          {
            title:
              "Beyond the West: How China and Emerging Markets will Shape shrimp demand",
            speaker: "Joash Mathew",
            bioId: 9,
          },
          {
            title: "Owing the Narrative of India's Shrimp Industry ",
            speaker: "Nitin Awasthi",
            bioId: 10,
          },
        ],
      },
      {
        id: "session2",
        title: "Session 2 - Disease Mitigation",
        icon: Shield,
        venue: "Conference Room B",
        moderator: "Dr. Ramesh Kumar D",
        bioId: 11,
        talks: [
          {
            title:
              "Key Strategies for Shrimp Disease Prevention: Biosecurity, Husbandry and Surveillance",
            speaker: "Dr. Victoria Alday Sanz",
            bioId: 12,
          },
          {
            title:
              "Microbial ecology and Vibrio dynamics: The hidden drivers of Shrimp Pond performance",
            speaker: "Dr. Stephen G Newman",
            bioId: 13,
          },
          {
            title:
              "Why Complex Gut Ecosystems cannot be Treated with One-size-fits-all Therapies",
            speaker: "Dr. Ramesh Kumar D",
            bioId: 11,
          },
          {
            title:
              "Fresh thinking for shrimp health management: New concepts across the production cycle. ",
            speaker: "Prof. Andrew Shinn",
            bioId: 14,
          },
        ],
      },
      {
        id: "session3",
        title: "Session 3 - Rethink Feed",
        icon: Package,
        venue: "Grand Ballroom",
        moderator: "Dr.Victor Suresh",
        bioId: 15,
        panelMembers: [
          {
            name: "Dr. K. Ambashankar",
            affiliation:
              "ICAR-Central Institute of Brackishwater Aquaculture, India",
            bioId: 16,
          },
          {
            name: "Dr. Daranee Seguin",
            affiliation: "Aker Qrill Company, Thailand",
            bioId: 17,
          },
          {
            name: "Dr. Jean-Benoit Darodes de Tailly",
            affiliation: "Phileo by Lesaffre, France",
            bioId: 18,
          },
          {
            name: "Dr. M. Rajalekshmi",
            affiliation: "Kemin AquaScience, India",
            bioId: 19,
          },
          {
            name: "Mr. B. Ravikumar",
            affiliation: "Growel Feeds, India",
            bioId: 20,
          },
          {
            name: "Dr. P.E. Vijay Anand",
            affiliation: "USSEC, India",
            bioId: 21,
          },
        ],
      },
    ],
  },
  day2: {
    date: "31 January 2026",
    sessions: [
      {
        id: "session4",
        title: "Session 4: Turning the Tide towards the Domestic Market",
        icon: TrendingUp,
        venue: "Main Convention Hall",
        moderator: "Ms. Kavitha Reddy Yarabolu",
        bioId: 22,
        talks: [
          {
            title:
              "Making prawn a Household Staple: A 4P Framework for Domestic Market Expansion ",
            speaker: "Shan Kadavil",
            bioId: 33,
          },
          {
            title: "The Retail Market Landscape for Farmed Shrimp in India  ",
            speaker: "Arjun Gadre",
            bioId: 23,
          },

          {
            title: "Culinary Excellence of Prawns  ",
            speaker: "Chef K. Thirugnanasambantham,",
            bioId: 34,
          },
          {
            title: "​Prawn: Where Nutrition Meets Taste  ",
            speaker: "Varsha Easwaran​",
            bioId: 35,
          },
        ],
      },
      {
        id: "session5",
        title: "Session 5: Product Diversification",
        icon: Lightbulb,
        venue: "Conference Room A",
        moderator: "Mr. S. Santhana Krishnan",
        bioId: 24,
        speakers: [
          { name: "Willem van der Pijl", bioId: 8 },
          { name: "Zubin Minoo Mehta", bioId: 26 },
          { name: "Manavendra Rao", bioId: 27 },
          { name: "M. Sudhakar", bioId: 28 },
          { name: "Pervez Ahmed Khan", bioId: 29 },
        ],
      },
      {
        id: "session6",
        title: "Session 6: Innovations & New Technologies",
        icon: Lightbulb,
        venue: "Innovation Lab",
        moderator: "Dr. G. Ramesh",
        bioId: 30,
        talks: [
          {
            title: "Innovations and New Technologies in Indian Shrimp Farming.",
            speaker: "Dr. Kuldeep Kumar Lal",
            bioId: 4,
          },
          {
            title: "Stackable Aquaculture systems",
            speaker: "John Deiner",
            bioId: 31,
          },
          {
            title: "IoT and Automation: Opportunities in Shrimp Farming",
            speaker: "Pavan Kosaraju",
            bioId: 32,
          },

          {
            title: " Innovative Farming Systems in China ",
            speaker: "Dr. Rajeev Jha",
            bioId: 36,
          },
        ],
      },
    ],
  },
};
